import { render, staticRenderFns } from "./grupi1.vue?vue&type=template&id=62fbd328&scoped=true&"
import script from "./grupi1.vue?vue&type=script&lang=js&"
export * from "./grupi1.vue?vue&type=script&lang=js&"
import style0 from "./grupi1.vue?vue&type=style&index=0&id=62fbd328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fbd328",
  null
  
)

export default component.exports